import { createFileRoute } from '@tanstack/react-router';
import type { BranchModeration } from '@/entities/branch';
import { BranchesPage } from '@/pages/menu/branches';
import { requireAuth } from '../require-auth';
import { menuSearchSchema } from '../menu-search';

// No loader prefetch: the list is keyed by the active branch, which is only
// known once the branch list has loaded (see `useMerchantScope`). Prefetching
// here would either fire with an empty scope or duplicate the branch request,
// so the page's own query owns the fetch.
export const Route = createFileRoute('/eats/menu_/branches')({
  // Auth guard — see `require-auth.ts`. Runs before the component mounts,
  // so no query fires without a session.
  beforeLoad: requireAuth,
  validateSearch: menuSearchSchema,
  component: BranchesRoute,
});

function BranchesRoute() {
  const { search, status, showcase } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <BranchesPage
      search={search}
      status={status as BranchModeration | undefined}
      showcase={showcase ?? false}
      onToggleShowcase={() => {
        void navigate({
          search: (prev) => ({
            ...prev,
            showcase: prev.showcase ? undefined : true,
          }),
        });
      }}
    />
  );
}
